// #region Global Imports
import { Dispatch } from "redux";
// #endregion Global Imports

// #region Local Imports
import { ActionConsts } from "@Definitions";
// #endregion Local Imports

// #region Interface Imports
import { IHomePage } from "@Interfaces";
import Cookies from "js-cookie";
import { Cart } from "@Services/API/IndividualApi's/Cart";
import { IProduct } from "@Interfaces/Api/Product";
import { RootState } from "@Interfaces/redux";
// #endregion Interface Imports

const getGuestCartId = () => {
  return Cookies.get("guestCartId");
};

const getUserId = () => {
  return Cookies.get("userId");
};
const queryParam = () => {
  return `cartId=${getGuestCartId()}`;
};

export const CartActions = {
  DeleteCart: () => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      const result = await Cart.removeWithoutId!();
      dispatch(CartActions.ClearCart());
    };
  },
  AddToCart: (CartObj: any) => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      const cart: { productId: string | undefined; quantity: number }[] = [];
      let isMatched = false;
      try {
        const cartDetails = getState().CartReducer.cart;
        const cartItemsDetail = cartDetails?.cartItems || [];

        if (cartItemsDetail) {
          if (getUserId()) {
            cartItemsDetail.forEach(
              (cartItem: { product: IProduct; quantity: number }) => {
                if (CartObj.productId === cartItem.product._id) {
                  isMatched = true;
                  const object = {
                    productId: cartItem.product._id,
                    quantity: cartItem.quantity + 1,
                  };
                  cart.push(object);
                } else {
                  const obj = {
                    productId: cartItem.product._id,
                    quantity: cartItem.quantity,
                  };
                  cart.push(obj);
                }
              }
            );
            if (!isMatched) {
              cart.push(CartObj);
            }
            dispatch({ type: ActionConsts.Cart.showLoader });

            try {
              const response = await Cart.post!({ cart });
              dispatch({ type: ActionConsts.Cart.hideLoader });
              return dispatch(CartActions.GetMyCart());
            } catch (err) {
              dispatch({ type: ActionConsts.Cart.hideLoader });
              console.log(err);
            }
          } else {
            if (getState()?.CartReducer?.cart == null) {
              if (!isMatched) {
                cart.push(CartObj);
              }
              try {
                const response = await Cart.createCartForGuestUser!({ cart });
                return dispatch(CartActions.GetMyCart());
              } catch (err) {
                console.log(err);
              }
            } else if (getGuestCartId()) {
              cartItemsDetail.forEach(
                (cartItem: { product: IProduct; quantity: number }) => {
                  if (CartObj.productId === cartItem.product._id) {
                    isMatched = true;
                    const object = {
                      productId: cartItem.product._id,
                      quantity: cartItem.quantity + 1,
                    };
                    cart.push(object);
                  } else {
                    const obj = {
                      productId: cartItem.product._id,
                      quantity: cartItem.quantity,
                    };
                    cart.push(obj);
                  }
                }
              );
              if (!isMatched) {
                cart.push(CartObj);
              }

              try {
                dispatch({ type: ActionConsts.Cart.showLoader });
                const response = await Cart.putGuestGuest!(getGuestCartId(), {
                  cart,
                });
                dispatch({ type: ActionConsts.Cart.hideLoader });
                return dispatch(CartActions.GetMyCart());
              } catch (err) {
                dispatch({ type: ActionConsts.Cart.hideLoader });
                console.log(err);
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
  },

  DeleteCartItem: (
    cart: { productId: string | undefined; quantity: number }[]
  ) => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      if (getUserId()) {
        try {
          const response = await Cart.post!({ cart });
          return dispatch(CartActions.GetMyCart());
        } catch (err) {
          console.log(err);
        }
      } else if (getGuestCartId()) {
        try {
          const response = await Cart.putGuestGuest!(getGuestCartId(), {
            cart,
          });
          return dispatch(CartActions.GetMyCart());
        } catch (err) {
          console.log(err);
        }
      }
      // }
    };
  },

  GetMyCart: () => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      const cartDetails = getState().CartReducer.cart;
      // if (cartDetails == null) {
      //   dispatch({ type: ActionConsts.Cart.ShowCartLoader });
      // } else {
      //   dispatch({ type: ActionConsts.Cart.HideCartLoader });
      // }
      if (getUserId()) {
        try {
          dispatch({ type: ActionConsts.Cart.ShowCartLoader });

          const response = await Cart.getCartAddedByAuthenticateUser();
          const myCart = response;
          return dispatch({
            payload: { cart: myCart },
            type: ActionConsts.Cart.AddToCart,
          });
        } catch (err) {
          console.log(err);
          return dispatch(CartActions.ClearCart());
        } finally {
          dispatch({ type: ActionConsts.Cart.HideCartLoader });
        }
      } else if (getGuestCartId()) {
        dispatch({ type: ActionConsts.Cart.ShowCartLoader });

        try {
          const response = await Cart.getCartAddedByGuest!(queryParam());
          const myCart = response;
          return dispatch({
            payload: { cart: myCart },
            type: ActionConsts.Cart.AddToCart,
          });
        } catch (err) {
          console.log(err);
          return dispatch(CartActions.ClearCart());
        } finally {
          dispatch({ type: ActionConsts.Cart.HideCartLoader });
        }
      }
    };
  },

  ClearCart: () => ({
    type: ActionConsts.Cart.ClearCart,
  }),

  CartQuantityChange: (CartObj: any) => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
      const cart: { productId: string | undefined; quantity: number }[] = [];
      dispatch({ type: ActionConsts.Cart.showLoader });
      try {
        const cartDetails = getState().CartReducer.cart;
        const cartItemsDetail = cartDetails?.cartItems || [];
        if (cartItemsDetail) {
          if (getUserId()) {
            cartItemsDetail.forEach(
              (cartItem: { product: IProduct; quantity: number }) => {
                if (CartObj.productId === cartItem.product._id) {
                  const object = {
                    productId: cartItem.product._id,
                    quantity: CartObj.quantity,
                  };
                  cart.push(object);
                } else {
                  const obj = {
                    productId: cartItem.product._id,
                    quantity: cartItem.quantity,
                  };
                  cart.push(obj);
                }
              }
            );
            try {
              const response = await Cart.post!({ cart });
              dispatch({ type: ActionConsts.Cart.hideLoader });
              return dispatch(CartActions.GetMyCart());
            } catch (err) {
              dispatch({ type: ActionConsts.Cart.hideLoader });
              console.log(err);
            }
          } else {
            if (getState()?.CartReducer?.cart == null) {
              try {
                const response = await Cart.createCartForGuestUser!({ cart });
                dispatch({ type: ActionConsts.Cart.hideLoader });
                return dispatch(CartActions.GetMyCart());
              } catch (err) {
                dispatch({ type: ActionConsts.Cart.hideLoader });
                console.log(err);
              }
            } else if (getGuestCartId()) {
              cartItemsDetail.forEach(
                (cartItem: { product: IProduct; quantity: number }) => {
                  if (CartObj.productId === cartItem.product._id) {
                    let Quantity = 0;
                    const object = {
                      productId: cartItem.product._id,
                      quantity: CartObj.quantity,
                    };
                    cart.push(object);
                  } else {
                    const obj = {
                      productId: cartItem.product._id,
                      quantity: cartItem.quantity,
                    };
                    cart.push(obj);
                  }
                }
              );

              try {
                const response = await Cart.putGuestGuest!(getGuestCartId(), {
                  cart,
                });
                dispatch({ type: ActionConsts.Cart.hideLoader });
                return dispatch(CartActions.GetMyCart());
              } catch (err) {
                dispatch({ type: ActionConsts.Cart.hideLoader });
                console.log(err);
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
  },
  setShippingCharge: (price: number) => {
    return {
      type: ActionConsts.Cart.setShippingCharge,
      payload: price,
    };
  },
  setEstimateDeliveyDate: (estimateDeliveryDate: string) => {
    return {
      type: ActionConsts.Cart.setEstimateDeliveyDate,
      payload: estimateDeliveryDate,
    };
  },
  setHeaderNotification: (headerNotification: []) => {
    return {
      type: ActionConsts.Cart.setHeaderNotification,
      payload: headerNotification,
    };
  },
};
